const variables = {
  headerHeight: 65,
  footerHeight: 50,
  hoverColor: "#FFCE70",
};

export default variables;
